/*!

=========================================================
* Material Dashboard React - v1.9.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/material-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
// @material-ui/icons
// import Dashboard from "@material-ui/icons/Dashboard";
import LibraryBooks from "@material-ui/icons/LibraryBooks";
// core components/views for Admin layout
// import DashboardPage from "views/Dashboard/Dashboard.js";

import GerenciarAlunos from "views/Alunos/Gerenciar.js";
import GerenciarUnidades from "views/Units/Gerenciar.js";
import GerenciarAtividades from "views/Activities/Gerenciar.js";
import GerenciarNiveis from "views/Levels/Gerenciar.js";
import GerenciarAudios from "views/Audios/Gerenciar.js";

const dashboardRoutes = [
  // {
  //   path: "/dashboard",
  //   name: "Dashboard",
  //   icon: Dashboard,
  //   component: DashboardPage,
  //   layout: "/admin"
  // },
  {
    path: "/alunos/gerenciar",
    name: "Gerenciar Alunos",
    icon: "content_paste",
    component: GerenciarAlunos,
    layout: "/admin"
  },
  {
    path: "/livros/gerenciar",
    name: "Gerenciar Livros",
    icon: "list_number",
    component: GerenciarNiveis,
    layout: "/admin"
  },
  {
    path: "/unidades/gerenciar",
    name: "Gerenciar Unidades",
    icon: LibraryBooks,
    component: GerenciarUnidades,
    layout: "/admin"
  },
  {
    path: "/atividades/gerenciar",
    name: "Gerenciar Atividades",
    icon: "extension",
    component: GerenciarAtividades,
    layout: "/admin"
  },
  {
    path: "/audios/gerenciar",
    name: "Gerenciar Audios",
    icon: "audiotrack",
    component: GerenciarAudios,
    layout: "/admin"
  }
];

export default dashboardRoutes;
